export default "__VITE_ASSET__D7Fj4vup__"